import {
  IRichTextObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  PaintStyle,
  TextStyle,
} from "../../../../domain/drawing";
import {
  RichTextBoxItem,
} from "../../../../domain/document/items";
import { AbstractTextObjectStyleReader } from "./AbstractTextObjectStyleReader";
import { FixedColorSource } from "./FixedColorSource";

export class RichTextObjectStyleReader extends AbstractTextObjectStyleReader<RichTextBoxItem> {
  constructor(private readonly _configuration: IRichTextObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: RichTextBoxItem, shouldInputFree: boolean): PaintStyle {
    return source.paintStyleOnEditing;
  }

  protected readBackgroundColorConfiguration(source: RichTextBoxItem, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  protected readBorderColorConfiguration(source: RichTextBoxItem, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  private readObjectStyleConfiguration(source: RichTextBoxItem, shouldInputFree: boolean): IObjectColorConfiguration {
    if (source.injectedRule && source.injectedRule.isEditDisabled) {
      return FixedColorSource.uneditable;
    }
    if (!source.isFreeInputable) {
      // 文書内転記が指定されている、もしくはフリー入力が不可に指定されているオブジェクト
      // フリー入力不可の場合に関連付けの色が適用されるのはV1のバグと思われるが、同様の挙動に合わせこんでいる
      return this._configuration.related;
    }
    return source.printBehavior.shouldPrint
      ? this._configuration.default
      : this._configuration.notPrintable;
  }

  public readTextStyle(source: RichTextBoxItem, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    return isFocused
      ? this.toFreeInputTextStyle(source)
      : this.toTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
